import api from './api'

const url = 'income-report'

export const getIncomeReportByYear = (year) => api.get(`${url}/${year}`, { responseType: 'arraybuffer', timeout: 60000 })
